import { createResource, createEndpoint } from './Schema';
import { ShareModel } from './Schema/Models';
import api from './Schema/Api';

/*
 * static s'applique au model
 * methods s'applique à la resource
 */
const sync = false;
const methods = {};

const ShareResource = createResource(api, ShareModel, {
  static: { sync },
  methods,
});

export const Share = createEndpoint(ShareResource, '', { static: {} });
